export const attendee = {
    topicHub: (roomSlug: string): string => `/rooms/${roomSlug}/topic-hub/`,
    topicHubDetails: (roomSlug: string, id: string): string =>
        `/rooms/${roomSlug}/topic-hub/${id}/`,
    topicHubMeetingOutcomes: (roomSlug: string, topicId: string): string =>
        `/rooms/${roomSlug}/topic-hub/${topicId}/meeting-outcomes/`,
    topicHubDocument: (roomSlug: string, requestId: string, attachmentId: string): string =>
        `/rooms/${roomSlug}/topic-hub/${requestId}/document/${attachmentId}/`,
    topicHubUnallocatedDocument: (roomSlug: string, attachmentId: string): string =>
        `/rooms/${roomSlug}/topic-hub/document/${attachmentId}/`
};

export const admin = {
    topicHub: (roomSlug: string): string => `/administrator/rooms/${roomSlug}/topic-hub/`,
    topicHubDetails: (roomSlug: string, id: string): string =>
        `/administrator/rooms/${roomSlug}/topic-hub/${id}/`,
    topicHubDetailsShowClosed: (roomSlug: string, id: string): string =>
        `/administrator/rooms/${roomSlug}/topic-hub/${id}/?showClosed=true`,
    topicHubMeetingOutcomes: (roomSlug: string, topicId: string): string =>
        `/administrator/rooms/${roomSlug}/topic-hub/${topicId}/meeting-outcomes/`,
    topicHubDocument: (roomSlug: string, requestId: string, attachmentId: string): string =>
        `/administrator/rooms/${roomSlug}/topic-hub/${requestId}/document/${attachmentId}/`,
    topicHubUnallocatedDocument: (roomSlug: string, attachmentId: string): string =>
        `/administrator/rooms/${roomSlug}/topic-hub/document/${attachmentId}/`
};

export const api = {
    loadRequests: (): string => '/api/agenda_item_requests/',
    loadRequestDetails: (requestId: string, roomId: string): string =>
        `/api/agenda_item_requests/${requestId}/?room_id=${roomId}`,
    loadRequestAttachments: (requestId: string): string =>
        `/api/agenda_item_requests/${requestId}/documents/`,
    loadRequestUnattachedDocuments: (roomId: string): string =>
        `/api/agenda_item_requests/unattached_documents/?room_id=${roomId}`,
    loadRequesters: (): string => '/api/agenda_item_requests/requesters/',
    loadRequestMeetings: (): string => '/api/agenda_item_requests/scheduled_meetings/',
    loadTopics: () => '/api/topics/',
    updateTopic: (topicId: string): string => `/api/topics/${topicId}/`,
    deleteTopic: (topicId: string): string => `/api/topics/${topicId}/`,
    loadTopicDetails: (topicId: string): string => `/api/topics/${topicId}/`,
    markRequestAsRead: (): string => '/api/agenda_item_requests/mark_as_read/',
    deleteRequest: (requestId: string, roomId: string): string =>
        `/api/agenda_item_requests/${requestId}/?room_id=${roomId}`,
    bulkDeleteRequest: (roomId: string): string =>
        `/api/agenda_item_requests/bulk_delete/?room_id=${roomId}`,
    loadUpcomingMeetings: (): string => '/api/events/',
    scheduleRequest: (requestId: string): string =>
        `/api/agenda_item_requests/${requestId}/schedule/`,
    bulkScheduleRequest: (roomId: string): string =>
        `/api/agenda_item_requests/bulk_schedule/?room_id=${roomId}`,
    requestAttachment: (requestId: string, attachmentId: string): string =>
        `/api/agenda_item_requests/${requestId}/documents/${attachmentId}/`,
    requestAttachmentPreview: (requestId: string, attachmentId: string): string =>
        `/api/agenda_item_requests/${requestId}/documents/${attachmentId}/preview/`,
    requestUnallocatedAttachmentPreview: (attachmentId: string): string =>
        `/api/agenda_item_requests/unattached_documents/${attachmentId}/preview/`,
    uploadRequestAttachment: (requestId: string): string =>
        `/api/agenda_item_requests/${requestId}/documents/`,
    uploadRequestUnattachedDocument: (roomId: string): string =>
        `/api/agenda_item_requests/unattached_documents/?room_id=${roomId}`,
    requestAttachDocument: (requestId: string, roomId: string) =>
        `/api/agenda_item_requests/${requestId}/attach/?room_id=${roomId}`,
    requestAttachmentDelete: (documentRequestId: string, attachmentId: string): string =>
        `/api/agenda_item_requests/${documentRequestId}/documents/${attachmentId}/`,
    requestUnattachedDocumentDelete: (attachmentId: string): string =>
        `/api/agenda_item_requests/unattached_documents/${attachmentId}/`,
    requestAttachmentUpdate: (documentRequestId: string, attachmentId: string): string =>
        `/api/agenda_item_requests/${documentRequestId}/documents/${attachmentId}/`,
    requestUnattachedDocumentUpdate: (attachmentId: string): string =>
        `/api/agenda_item_requests/unattached_documents/${attachmentId}/`,
    postRequest: (): string => '/api/agenda_item_requests/',
    updateRequest: (requestId: string): string => `/api/agenda_item_requests/${requestId}/`,
    copyRequest: (requestId: string): string => `/api/agenda_item_requests/${requestId}/clone/`,
    bulkCopyRequest: (roomId: string): string =>
        `/api/agenda_item_requests/bulk_clone/?room_id=${roomId}`,
    copyRequestTargetRooms: (): string => '/api/agenda_item_requests/allowed_target_rooms/',
    loadComments: (): string => '/api/comment_threads/agenda_item_requests/',
    postComment: (): string => '/api/comments/agenda_item_requests/',
    deleteComment: (commentId: string): string =>
        `/api/comments/agenda_item_requests/${commentId}/`,
    updateComment: (commentId: string): string =>
        `/api/comments/agenda_item_requests/${commentId}/`,
    loadMentionableMembers: (): string => '/api/comment_threads/agenda_item_requests/mentionable/',
    updateThread: (threadId: string): string =>
        `/api/comment_threads/agenda_item_requests/${threadId}/`,
    markCommentsAsRead: (): string => `/api/comments/agenda_item_requests/mark_as_read/`,
    topicHubDownload: (queryParams: string): string =>
        `/api/agenda_item_requests/export/?${queryParams}`,
    updateTopicStatusToOpen: (topicId: string): string =>
        `/api/agenda_item_requests/${topicId}/open/`,
    bulkUpdateTopicStatusToOpen: (roomId: string): string =>
        `/api/agenda_item_requests/bulk_open/?room_id=${roomId}`,
    meetingOutcomes: (topicId: string): string => `/api/topics/${topicId}/meeting_outcomes/`
};
